(function () {
  const qs = (selector, scope) => (scope || document).querySelector(selector);
  const qsa = (selector, scope) => Array.from((scope || document).querySelectorAll(selector));

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, ' ');
  }

  function formatMoney(amount) {
    const moneyFormat = (window.Shopify && (window.Shopify.money_format || (window.theme && window.theme.moneyFormat))) || '${{amount}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amount, moneyFormat);
    }
    const value = Number(amount || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(value);
  }

  function detectCategory(term, form) {
    const normalized = normalize(term);
    const categories = [
      { keywords: ['collar', 'collares'], url: form.dataset.categoryCollaresUrl || '/pages/collares' },
      { keywords: ['pulsera', 'pulseras'], url: form.dataset.categoryPulserasUrl || '/pages/pulseras' },
      { keywords: ['aro', 'aros'], url: form.dataset.categoryArosUrl || '/pages/aros' }
    ];
    return categories.find((category) => category.keywords.includes(normalized)) || null;
  }

  function initHeader() {
    qsa('[data-pm-header]').forEach((shell) => {
      if (shell.dataset.pmHeaderInit === '1') return;
      shell.dataset.pmHeaderInit = '1';

      const toggle = qs('[data-pm-mobile-toggle]', shell);
      const panel = qs('[data-pm-mobile-panel]', shell);

      const closePanel = () => {
        if (!toggle || !panel) return;
        toggle.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      };

      if (toggle && panel) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          const isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          panel.hidden = isOpen;
          if (!isOpen) {
            const input = qs('input[type="search"]', panel);
            if (input) window.setTimeout(() => input.focus(), 40);
          }
        });

        // Sólo los links con data-nav-close cierran el panel (no el summary del accordion)
        qsa('[data-nav-close]', panel).forEach((link) => {
          link.addEventListener('click', closePanel);
        });
      }

      document.addEventListener('click', (event) => {
        if (!panel || panel.hidden) return;
        if (shell.contains(event.target)) return;
        closePanel();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePanel();
      });
    });
  }

  function initDropdowns() {
    qsa('[data-pm-dropdown]').forEach((wrap) => {
      if (wrap.dataset.pmDropdownInit === '1') return;
      wrap.dataset.pmDropdownInit = '1';

      const trigger = qs('.pm-nav__dropdown-trigger', wrap);
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = wrap.hasAttribute('data-open');
        // Cierra cualquier otro dropdown abierto
        qsa('[data-pm-dropdown][data-open]').forEach((w) => {
          w.removeAttribute('data-open');
          const t = qs('.pm-nav__dropdown-trigger', w);
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          wrap.setAttribute('data-open', '');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Clic fuera cierra el dropdown
    document.addEventListener('click', () => {
      qsa('[data-pm-dropdown][data-open]').forEach((w) => {
        w.removeAttribute('data-open');
        const t = qs('.pm-nav__dropdown-trigger', w);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        qsa('[data-pm-dropdown][data-open]').forEach((w) => {
          w.removeAttribute('data-open');
          const t = qs('.pm-nav__dropdown-trigger', w);
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function initSearch() {
    qsa('[data-pm-search]').forEach((form) => {
      if (form.dataset.pmSearchInit === '1') return;
      form.dataset.pmSearchInit = '1';

      const input = qs('input[type="search"]', form);
      const results = qs('[data-pm-search-results]', form);
      if (!input || !results) return;

      const genericLimit = Math.max(1, Number(form.dataset.genericLimit || 5));
      const specificLimit = Math.max(genericLimit, Number(form.dataset.specificLimit || 30));
      const noResultsTitle = form.dataset.noResultsTitle || 'Sin resultados';
      const noResultsTemplate = form.dataset.noResultsTemplate || 'No encontramos resultados para "__terms__".';
      const browseMoreLabel = form.dataset.browseMoreLabel || 'Ver más';
      const searchingLabel = form.dataset.searchingLabel || 'Buscando\u2026';
      const searchSuggestUrl = form.dataset.searchSuggestUrl || '/search/suggest.json';
      let debounceTimer = null;
      let controller = null;
      let activeTerm = '';

      const closeResults = () => {
        results.hidden = true;
        results.innerHTML = '';
        form.classList.remove('is-open');
        input.setAttribute('aria-expanded', 'false');
      };

      const openResults = () => {
        results.hidden = false;
        form.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      };

      const renderNoResults = (term) => {
        const message = noResultsTemplate.replace('__terms__', escapeHtml(term));
        results.innerHTML = '<div class="pm-search__empty"><strong>' + escapeHtml(noResultsTitle) + '</strong><p>' + message + '</p></div>';
        openResults();
      };

      const renderProducts = (products, term, categoryMeta) => {
        const isGeneric = Boolean(categoryMeta);
        const visibleProducts = isGeneric ? products.slice(0, genericLimit) : products;
        const items = visibleProducts.map((product) => {
          const imageSrc = typeof product.image === 'string'
            ? product.image
            : ((product.image && (product.image.url || product.image.src)) || (product.featured_image && (product.featured_image.url || product.featured_image.src)) || '');
          const imageMarkup = imageSrc
            ? '<span class="pm-search__thumb"><img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(product.title || '') + '" loading="lazy"></span>'
            : '<span class="pm-search__thumb pm-search__thumb--empty"></span>';
          return '<a class="pm-search__item" href="' + escapeHtml(product.url || '#') + '">' + imageMarkup + '<span class="pm-search__copy"><span class="pm-search__title">' + escapeHtml(product.title || '') + '</span></span></a>';
        }).join('');

        const showMoreButton = isGeneric && categoryMeta.url && products.length > genericLimit;
        const moreMarkup = showMoreButton
          ? '<a class="pm-search__more" href="' + escapeHtml(categoryMeta.url) + '">' + escapeHtml(browseMoreLabel) + '</a>'
          : '';

        results.innerHTML = '<div class="pm-search__list" role="listbox">' + items + '</div>' + moreMarkup;
        openResults();
      };

      const runSearch = async (rawTerm) => {
        const term = String(rawTerm || '').trim();
        activeTerm = term;
        if (term.length < 2) { closeResults(); return; }

        if (controller) controller.abort();
        controller = new AbortController();
        const categoryMeta = detectCategory(term, form);
        const requestLimit = categoryMeta ? Math.max(genericLimit + 5, 10) : specificLimit;

        results.innerHTML = '<div class="pm-search__status">' + escapeHtml(searchingLabel) + '</div>';
        openResults();

        try {
          const response = await fetch(
            searchSuggestUrl + '?q=' + encodeURIComponent(term) +
            '&resources[type]=product&resources[limit]=' + requestLimit +
            '&resources[options][prefix]=last&resources[options][unavailable_products]=last',
            { signal: controller.signal, headers: { Accept: 'application/json' } }
          );
          if (!response.ok) throw new Error('search-error');
          const data = await response.json();
          if (activeTerm !== term) return;
          const products = ((((data || {}).resources || {}).results || {}).products || []);
          if (!products.length) { renderNoResults(term); return; }
          renderProducts(products, term, categoryMeta);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          closeResults();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        const value = input.value || '';
        if (value.trim().length < 2) { closeResults(); return; }
        debounceTimer = window.setTimeout(() => runSearch(value), 180);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && results.innerHTML.trim() !== '') openResults();
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') { closeResults(); input.blur(); }
      });

      form.addEventListener('submit', (event) => {
        const term = input.value.trim();
        if (!term) { event.preventDefault(); closeResults(); return; }
        closeResults();
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initDropdowns();
    initSearch();
    // Ocultar badge del carrito cuando es 0
    document.querySelectorAll('.pm-cart-badge').forEach(function(badge) {
      if (badge.textContent.trim() === '0' || badge.textContent.trim() === '') {
        badge.style.display = 'none';
      }
    });
  });
})();
